import React, { useState } from 'react';
import useApiStable from '../../utils/useApiStable';

function DrinkAdminForm({ drink, onSave, onCancel }) {
    const [name, setName] = useState(drink?.name || '');
    const [price, setPrice] = useState(drink?.price != null ? String(drink.price) : '');
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const api = useApiStable();

    const handleSubmit = (e) => {
        e.preventDefault();
        setError('');
        setSaving(true);
        const payload = { name, price: parseFloat(price) };
        const request = drink
            ? api.put(`/drinks/${drink.id}`, payload)
            : api.post('/drinks', payload);
        request
            .then(() => onSave())
            .catch(err => setError(err.message || 'Fehler beim Speichern'))
            .finally(() => setSaving(false));
    };

    return (
        <form className="drink-admin-form" onSubmit={handleSubmit}>
            {error && <div className="drink-admin-error">{error}</div>}
            <div className="drink-admin-form-row">
                <input
                    type="text"
                    placeholder="Name"
                    value={name}
                    onChange={e => setName(e.target.value)}
                    required
                    disabled={saving}
                    className="drink-admin-input"
                />
                <input
                    type="number"
                    placeholder="Preis (€)"
                    value={price}
                    onChange={e => setPrice(e.target.value)}
                    min="0.01"
                    step="0.01"
                    required
                    disabled={saving}
                    className="drink-admin-input drink-admin-input--price"
                />
                <button type="submit" className="drink-admin-save-btn" disabled={saving || !name || !price}>
                    {saving ? 'Speichern...' : 'Speichern'}
                </button>
                <button type="button" className="drink-admin-cancel-btn" onClick={onCancel} disabled={saving}>
                    Abbrechen
                </button>
            </div>
        </form>
    );
}

export default DrinkAdminForm;
